import { render, staticRenderFns } from "./TeachingEdit.vue?vue&type=template&id=5b7a8a51&scoped=true&"
import script from "./TeachingEdit.vue?vue&type=script&lang=js&"
export * from "./TeachingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a8a51",
  null
  
)

export default component.exports